'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import timezoneLang from 'i2l?query=sporks!timezone-utils/lang/en.lyaml';

function changeLocale(locale, language) {
  var I18nProvider = createPublicI18nProvider({
    manuallySetLocale: true,
    excludeFallback: true
  });
  var translationsAvailablePromise = Promise.all([I18nProvider.register(lang), I18nProvider.register(timezoneLang)]);
  var langEnabled = language !== 'en';
  I18nProvider.setLocale({
    locale: locale,
    langEnabled: langEnabled
  });
  return translationsAvailablePromise;
}

export default (function (WrappingComponent) {
  function I18nLoader(props) {
    return /*#__PURE__*/_jsx(WrappingComponent, Object.assign({}, props, {
      changeLocale: changeLocale
    }));
  }

  I18nLoader.displayName = WrappingComponent.displayName ? "connectI18nLoader(" + WrappingComponent.displayName + ")" : 'connectI18nLoader(Component)';
  return I18nLoader;
});